package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.repository.UserRepository
import com.evoapps.evoshift.domain.repository.WorkplaceRepository
import com.evoapps.evoshift.domain.usecase.auth.GetCurrentUserUseCase
import kotlinx.coroutines.flow.first

class DeleteWorkplaceUseCase(
    private val workplaceRepository: WorkplaceRepository,
    private val userRepository: UserRepository,
    private val getCurrentUserUseCase: GetCurrentUserUseCase
) {
    suspend operator fun invoke(workplaceId: String): Result<Unit> {
        val user = getCurrentUserUseCase().first() ?: return Result.failure(Exception("User not logged in"))

        // The engagement first, so it disappears from the UI: firestore.rules let the owner change
        // their own engagement only while the workplace exists, and delete it afterwards.
        val endResult = userRepository.terminateEngagement(user.uid, workplaceId)
        if (endResult.isFailure) return endResult
        // The server (functions deleteWorkplace) then removes everything of the workplace: rosters,
        // shifts, pay snapshots, absences, people's engagements and pay terms (SH-50).
        return workplaceRepository.deleteWorkplace(workplaceId)
    }
}
